import { faBirthdayCake, faCalendarDays, faHandshake } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Avatar, Drawer, Empty } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useRef, useState } from 'react'
import JSConfetti from 'js-confetti'
import Carregando from '../../../CustomUi/loading'
import GavetaAniversariante from '../gavetaAniversariante'
import AvatarImg from './meta'

interface PropsLista {
  dados: any[]
  loading?: boolean
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>
}

const ListaAniversariantes: React.FC<PropsLista> = ({ dados, loading, setLoading }) => {
  const [open, setOpen] = useState(false)
  const [cod, setCod] = useState(0)
  const [erro, setErro] = useState(false)

  function abrirGaveta(cod) {
    setCod(cod)
    setOpen(true)
  }

  const getInitials = (name) => {
    if (!name) return ''
    return name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase()
  }

  if (loading) {
    return <Carregando justifyContent='center' height={400} legenda='Carregando...' animation />
  }

  return (
    <>
      {dados.length > 0 ? (
        dados.map((item, index) => {
          return (
            <div
              className='proximos__aniversariantes'
              key={index}
              data-hoje={item?.hoje}
              data-passou={dayjs(item?.dataBase).format('MM-DD') < dayjs().format('MM-DD')}
              onClick={() => abrirGaveta(item?.cod)}
            >
              <div className='avatar'>
                <AvatarImg src={(item?.doc_foto_perfil_url ?? item?.doc_foto_url)} nome={item?.nome} size={46} />
              </div>

              <div className='info__nome__data'>
                <p className='nome__aniversariante__lista' title={item?.nome}>
                  {`${item?.nome?.toLowerCase()} ${item?.sobrenome?.toLowerCase()}`}
                </p>
                <div className='data'>
                  <FontAwesomeIcon
                    style={{ fontSize: '12px' }}
                    icon={item?.tipo === 'nascimento' ? faBirthdayCake : faHandshake}
                  />
                  <p>{dayjs(item?.dataBase).format('DD/MM/YYYY')}</p>
                </div>
              </div>
            </div>
          )
        })
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<>Nenhum aniversariante no mês</>}
        />
      )}
      <GavetaAniversariante cod={cod} open={open} setOpen={setOpen} dados={dados} />
    </>
  )
}

export default ListaAniversariantes
